import React, { useEffect, useState } from "react";
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import OndConnectionSettings from "./OndConnectionSettings";
import { updateOndConnection } from "../../services/api";
import { ondMessage } from "../../i18n/ondMessages";

export default function OndConnectionDialog({ open, onClose, onSaved, name, characteristics, accessToken, greek }) {
  const [connection, setConnection] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const tr = (el, en) => greek ? el : en;
  useEffect(() => {
    if (open) {
      setConnection(characteristics?.ondConnection || { mode: "unknown" });
      setError("");
    }
  }, [open, name, characteristics]);
  const save = async () => {
    setBusy(true);
    setError("");
    try {
      const result = await updateOndConnection(name, connection, accessToken);
      onSaved(result.characteristics);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };
  return <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="md">
    <DialogTitle>{tr("Σύνδεση εισόδων DC", "DC input connection")} — {name}</DialogTitle>
    <DialogContent dividers>
      <OndConnectionSettings characteristics={{ ...characteristics, ondConnection: connection }} onChange={setConnection} greek={greek} disabled={busy} />
    </DialogContent>
    <DialogActions sx={{ flexWrap: "wrap" }}>
      {error && <Alert severity="error" sx={{ width: "100%" }}>{ondMessage(error, greek)}</Alert>}
      <Button onClick={onClose} disabled={busy}>{tr("Ακύρωση", "Cancel")}</Button>
      <Button onClick={save} disabled={busy || !connection} variant="contained" startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}>
        {tr("Αποθήκευση", "Save")}
      </Button>
    </DialogActions>
  </Dialog>;
}
